<h3-autocomplete-chips
  [autoCompleteValueOnEnter]="false"
  [excludedValues]="blacklist"
  [allowedValues]="whitelist"
  [nasModel]="outputInfoStore('answer')"
  [availableValuesOnly]="!!whitelist?.length"
  [allowDuplicatedValue]="false"
  [disabled]="form.controls.input.disabled"
></h3-autocomplete-chips>
